import { eur, fileUrl } from "@/lib/api";

const Row = ({ l, v }) => (v ? <div className="flex gap-3 text-sm"><span className="w-40 shrink-0 text-[var(--muted)]">{l}</span><span className="whitespace-pre-line break-words min-w-0">{v}</span></div> : null);

export function ImpView({ v }) {
  const d = v.data;
  const t = v.totals;
  const s = v.signature;
  const sv = d.delivery.services;
  const services = [sv.trasporto && "Trasporto", sv.montaggio && "Montaggio", sv.altro].filter(Boolean).join(", ");
  return (
    <div className="space-y-5" data-testid="imp-view">
      <div className="rounded-2xl bg-white border border-[var(--border)] p-5 space-y-2">
        <p className="eyebrow">Cliente</p>
        <Row l="Nome e cognome" v={d.customer.name} /><Row l="Telefono" v={d.customer.phone} /><Row l="Indirizzo" v={d.customer.address} /><Row l="Info accesso" v={d.customer.access_info} />
      </div>
      <div className="rounded-2xl bg-white border border-[var(--border)] p-5">
        <p className="eyebrow mb-2">Merce</p>
        <ul className="divide-y divide-[var(--border)]">
          {d.items.map((i, idx) => (
            <li key={idx} className="py-2 flex justify-between gap-3 text-sm" data-testid={`imp-view-item-${idx}`}>
              <span className="min-w-0"><span className="font-medium">{i.qty} × {i.description}</span>{i.notes && <span className="block text-xs text-[var(--muted)]">{i.notes}</span>}</span>
              <span className="font-mono shrink-0">{eur(i.qty * i.price)}</span>
            </li>
          ))}
        </ul>
        <div className="mt-3 rounded-xl bg-[var(--surface-2)] p-4 text-sm font-mono space-y-1">
          {[["Totale merce", t.goods], ["Trasporto", t.transport], ["Montaggio", t.assembly], [`Altri costi${d.other_costs_desc ? ` (${d.other_costs_desc})` : ""}`, t.other_costs]].map(([l, x]) => <div key={l} className="flex justify-between"><span className="font-sans">{l}</span><span>{eur(x)}</span></div>)}
          <div className="flex justify-between font-bold border-t pt-1"><span className="font-sans">Totale complessivo</span><span data-testid="imp-view-total">{eur(t.total)}</span></div>
          <div className="flex justify-between"><span className="font-sans">{d.paid_type === "acconto" ? "Acconto versato" : "Caparra confirmatoria"}</span><span>{eur(t.paid)}</span></div>
          <div className="flex justify-between font-bold text-[var(--primary-hover)]"><span className="font-sans">Saldo residuo</span><span data-testid="imp-view-balance">{eur(t.balance)}</span></div>
        </div>
      </div>
      <div className="rounded-2xl bg-white border border-[var(--border)] p-5 space-y-2">
        <p className="eyebrow">Consegna</p>
        <Row l="Indirizzo" v={d.delivery.address || d.customer.address || "Ritiro in sede"} /><Row l="Data prevista" v={d.delivery.date && new Date(d.delivery.date + "T00:00").toLocaleDateString("it-IT")} />
        <Row l="Fascia oraria" v={d.delivery.time_slot} /><Row l="Piano / accessibilità" v={d.delivery.floor_info} /><Row l="Servizi" v={services} /><Row l="Note personale" v={d.delivery.staff_notes} />
        <Row l="Accordi specifici" v={d.specific_agreements} />
      </div>
      {s && (
        <div className="rounded-2xl bg-white border border-emerald-200 p-5 space-y-3" data-testid="imp-view-signatures">
          <p className="text-sm text-emerald-700 font-semibold">Firmata il {new Date(s.signed_at).toLocaleString("it-IT")} · operatore {s.staff_name} · versione {v.version}</p>
          <p className="text-[11px] font-mono text-[var(--muted)] break-all">SHA-256 {s.document_hash}</p>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><p className="eyebrow mb-1">Cliente – {s.client_name}</p><img src={fileUrl(s.client_signature_path)} alt="Firma cliente" className="rounded-xl border bg-white w-full max-h-40 object-contain" /></div>
            <div><p className="eyebrow mb-1">Incaricato SUK – {s.staff_name}</p><img src={fileUrl(s.staff_signature_path)} alt="Firma incaricato" className="rounded-xl border bg-white w-full max-h-40 object-contain" /></div>
          </div>
        </div>
      )}
    </div>
  );
}
